import { withLenses } from '@dhmk/zustand-lens';
import { useMemo } from 'react';
import { useStoreStateLensFocus } from 'src/providers/StoreStateLensFocusProvider';
import { useStoreState } from 'src/providers/StoreStateProvider';
import { immer } from 'zustand/middleware/immer';

export function createUseStoreState<State>(lens: string) {
  return <Selected>(selector: (state: State) => Selected): Selected => {
    const lensSelector = useStoreStateLensFocus(lens);

    return useStoreState((state: Record<string, State>) => {
      return selector(lensSelector(state)) as Selected;
    });
  };
}

export function useLensedStore(lenses: Parameters<typeof withLenses>[0], deps?: unknown[]) {
  return useMemo(() => immer(withLenses(lenses)), [lenses, ...(deps ?? [])]);
}
